export default __webpack_public_path__ + "static/media/person-3.55ea32ad.webp";